export const Statuses = {
  Confirmed: 'confirmed',
  Unconfirmed: 'unconfirm',
};

export const ConnectionStatuses = {
  Connected: '串接完成',
  Unconnected: '未串接',
  Pending: '串接中',
};

export const Categories = {
  Shopee: 'Shopee',
  // PChome: 'PChome',
};

export default class Market {
  constructor(data) {
    this.id = '';
    this.serial = '0000';
    this.name = '';
    this.category = Categories.Shopee;
    this.url = '';
    this.fanPageUrl = '';
    this.fanPageStatus = Statuses.Unconfirmed;
    this.status = ConnectionStatuses.Unconnected;

    this.initialize(data);
  }

  initialize(data = {}) {
    this.id = data.id ?? this.id;
    this.serial = data.number ?? data.serial ?? this.serial;
    this.name = data.name ?? this.name;
    this.category = data.type ?? data.category ?? this.category;
    this.url = data.mallUrl ?? data.url ?? this.url;
    this.fanPageUrl = data.fanPageUrl ?? this.fanPageUrl;
    this.fanPageStatus = data.fanPageStatus ?? this.fanPageStatus;
    this.status = data.status || this.status;
  }

  clone() {
    const m = new Market();
    m.id = this.id;
    m.serial = this.serial;
    m.name = this.name;
    m.category = this.category;
    m.url = this.url;
    m.fanPageUrl = this.fanPageUrl;
    m.fanPageStatus = this.fanPageStatus;
    m.status = this.status;
    return m;
  }

  toNewJSON() {
    const json = {};
    json.number = this.serial;
    json.name = this.name;
    json.type = this.category;
    json.mallUrl = this.url;
    json.fanPageUrl = this.fanPageUrl;
    json.fanPageStatus = this.fanPageStatus;
    // json.connected = this.connected;
    return json;
  }

  toJSON() {
    const json = {};
    json.id = this.id;
    json.number = this.serial;
    json.name = this.name;
    json.type = this.category;
    json.mallUrl = this.url;
    json.fanPageUrl = this.fanPageUrl;
    json.fanPageStatus = this.fanPageStatus;
    // json.connected = this.connected;
    return json;
  }
}
